export default __webpack_public_path__ + "static/media/s663-2.5a309636.png";